import get from 'lodash/get';
import has from 'lodash/has';
import { cellTypes } from '../enums';

const sortAsc = (players, property, checkRule) => {
    return [...players].sort((a, b) => {
        if (property !== 'position.sortValue') {
            const compareCutResult = compareByCut(a, b);

            if (compareCutResult !== 0) {
                return compareCutResult;
            }
        }

        let aVal = 0;
        let bVal = 0;
        if (has(a, property)) {
            const aPropValue = get(a, property);
            if (checkRule !== null && checkRule !== undefined) {
                aVal = checkRule(aPropValue);
            } else {
                aVal = Number.parseInt(aPropValue, 10);
            }
        }
        if (has(b, property)) {
            const bPropValue = get(b, property);
            if (checkRule !== null && checkRule !== undefined) {
                bVal = checkRule(bPropValue);
            } else {
                bVal = Number.parseInt(bPropValue, 10);
            }
        }

        return aVal - bVal;
    });
};

const sortDesc = (players, property, checkRule) => {
    return [...players].sort((a, b) => {
        if (property !== 'position.sortValue') {
            const compareCutResult = compareByCut(a, b);

            if (compareCutResult !== 0) {
                return compareCutResult;
            }
        }

        let aVal = 0;
        let bVal = 0;
        if (has(a, property)) {
            const aPropValue = get(a, property);
            if (checkRule !== null && checkRule !== undefined) {
                aVal = checkRule(aPropValue);
            } else {
                aVal = Number.parseInt(aPropValue, 10);
            }
        }
        if (has(b, property)) {
            const bPropValue = get(b, property);
            if (checkRule !== null && checkRule !== undefined) {
                bVal = checkRule(bPropValue);
            } else {
                bVal = Number.parseInt(bPropValue, 10);
            }
        }

        return bVal - aVal;
    });
};

export const sortAscAZ = (players, property) => {
    return [...players].sort((a, b) => {
        if (property !== 'position.sortValue') {
            const compareCutResult = compareByCut(a, b);

            if (compareCutResult !== 0) {
                return compareCutResult;
            }
        }

        const aVal = getValueByProperties(a, property);
        const bVal = getValueByProperties(b, property);

        const aNormalized = (aVal || '').toLowerCase();
        const bNormalized = (bVal || '').toLowerCase();

        if (aNormalized === bNormalized) {
            if (isLastNameProperty(property)) {
                return compareByFirstName(a, b);
            }

            return 0;
        }

        return aNormalized > bNormalized ? 1 : -1;
    });
};

const sortDescAZ = (players, property) => {
    return [...players].sort((a, b) => {
        if (property !== 'position.sortValue') {
            const compareCutResult = compareByCut(a, b);

            if (compareCutResult !== 0) {
                return compareCutResult;
            }
        }

        const aVal = getValueByProperties(a, property);
        const bVal = getValueByProperties(b, property);

        const aNormalized = (aVal || '').toLowerCase();
        const bNormalized = (bVal || '').toLowerCase();

        if (aNormalized === bNormalized) {
            if (isLastNameProperty(property)) {
                return compareByFirstName(a, b);
            }

            return 0;
        }

        return aNormalized < bNormalized ? 1 : -1;
    });
};

function compareByCut(playerA, playerB) {
    const cutProperty = 'position.displayValue';
    let aCutVal = 'z';
    let bCutVal = 'z';

    if (has(playerA, cutProperty)) {
        aCutVal = get(playerA, cutProperty);
    }
    if (has(playerB, cutProperty)) {
        bCutVal = get(playerB, cutProperty);
    }

    if (aCutVal == null || bCutVal == null) {
        return 0;
    }

    statusCompare = compareByStatus(aCutVal, bCutVal, 'unknown');
    if (statusCompare !== 0) {
        return statusCompare;
    }

    statusCompare = compareByStatus(aCutVal, bCutVal, 'rtd');
    if (statusCompare !== 0) {
        return statusCompare;
    }

    statusCompare = compareByStatus(aCutVal, bCutVal, 'mcdnp');
    if (statusCompare !== 0) {
        return statusCompare;
    }

    statusCompare = compareByStatus(aCutVal, bCutVal, 'dqc');
    if (statusCompare !== 0) {
        return statusCompare;
    }

    statusCompare = compareByStatus(aCutVal, bCutVal, 'wdc');
    if (statusCompare !== 0) {
        return statusCompare;
    }

    statusCompare = compareByStatus(aCutVal, bCutVal, 'dns');
    if (statusCompare !== 0) {
        return statusCompare;
    }

    statusCompare = compareByStatus(aCutVal, bCutVal, 'dq');
    if (statusCompare !== 0) {
        return statusCompare;
    }

    statusCompare = compareByStatus(aCutVal, bCutVal, 'wd');
    if (statusCompare !== 0) {
        return statusCompare;
    }

    let statusCompare = compareByStatus(aCutVal, bCutVal, 'cut');
    if (statusCompare !== 0) {
        return statusCompare;
    }

    return 0;
}

function compareByStatus(playerAStatus, playerBStatus, status) {
    if (playerAStatus.toLowerCase() === status && playerBStatus.toLowerCase() !== status) {
        return 1;
    }

    if (playerAStatus.toLowerCase() !== status && playerBStatus.toLowerCase() === status) {
        return -1;
    }

    return 0;
}

export const sortingStrategies = {
    [cellTypes.POSITION]: {
        filteringFunc: (players, isAsc) => {
            return isAsc ?
                sortAsc(players, 'position.sortValue') :
                sortDesc(players, 'position.sortValue');
        }
    },
    [cellTypes.MOVERS]: {
        filteringFunc: (players, isAsc) => {
            return isAsc ? sortAsc(players, 'movers') : sortDesc(players, 'movers');
        }
    },
    [cellTypes.PLAYER]: {
        filteringFunc: (players, isAsc) => {
            return isAsc ?
                sortAscAZ(players, ['sitecoreData.lastName', 'lastName']) :
                sortDescAZ(players, ['sitecoreData.lastName', 'lastName']);
        }
    },
    [cellTypes.PAR]: {
        filteringFunc: (players, isAsc) => {
            const checkRule = (val) => {
                // make toParworse to move in the end
                if (!val || val.toUpperCase() === 'WD') return 1000;

                return val === 'E' ? 0 : parseInt(val, 10);
            };

            return isAsc ?
                sortAsc(players, 'toPar', checkRule) :
                sortDesc(players, 'toPar', checkRule);
        }
    },
    [cellTypes.HOLE]: {
        filteringFunc: (players, isAsc) => {
            const checkRule = (val) => {
                if (!val || val === '-') {
                    return 0;
                }

                return val === 'F' ? 19 : parseInt(val, 10);
            };

            return isAsc ?
                sortAsc(players, 'hole', checkRule) : sortDesc(players, 'hole', checkRule);
        }
    },
    [cellTypes.TOTAL]: {
        filteringFunc: (players, isAsc) => {
            const checkRule = (val) => {
                if (!val || val === '-') return 0;

                return parseInt(val, 10);
            };

            return isAsc ?
                sortAsc(players, 'total', checkRule) : sortDesc(players, 'total', checkRule);
        }
    },
    [cellTypes.TODAY]: {
        filteringFunc: (players, isAsc) => {
            const checkRule = (val) => {
                // make player par worse to move in the end
                if (!val || val === '-') return 1000;

                return val === 'E' ? 0 : parseInt(val, 10);
            };

            return isAsc ?
                sortAsc(players, 'today', checkRule) :
                sortDesc(players, 'today', checkRule);
        }
    },
    [cellTypes.R1]: {
        filteringFunc: (players, isAsc) => {
            const checkRule = (val) => {
                if (!val || val === '-') return 0;

                return parseInt(val, 10);
            };

            return isAsc ? sortAsc(players, 'r1', checkRule) : sortDesc(players, 'r1', checkRule);
        }
    },
    [cellTypes.R2]: {
        filteringFunc: (players, isAsc) => {
            const checkRule = (val) => {
                if (!val || val === '-') return 0;

                return parseInt(val, 10);
            };

            return isAsc ? sortAsc(players, 'r2', checkRule) : sortDesc(players, 'r2', checkRule);
        }
    },
    [cellTypes.R3]: {
        filteringFunc: (players, isAsc) => {
            const checkRule = (val) => {
                if (!val || val === '-') return 0;

                return parseInt(val, 10);
            };

            return isAsc ? sortAsc(players, 'r3', checkRule) : sortDesc(players, 'r3', checkRule);
        }
    },
    [cellTypes.R4]: {
        filteringFunc: (players, isAsc) => {
            const checkRule = (val) => {
                if (!val || val === '-') return 0;

                return parseInt(val, 10);
            };

            return isAsc ? sortAsc(players, 'r4', checkRule) : sortDesc(players, 'r4', checkRule);
        }
    }
};

const compareByFirstName = (a, b) => {
    const aFirstName = getValueByProperties(a, ['firstName', 'sitecoreData.firstName']);
    const bFirstName = getValueByProperties(b, ['firstName', 'sitecoreData.firstName']);

    const aFirstNameNormalized = (aFirstName || '').toLowerCase();
    const bFirstNameNormalized = (bFirstName || '').toLowerCase();

    if (aFirstNameNormalized === bFirstNameNormalized) {
        return 0;
    }

    return aFirstNameNormalized > bFirstNameNormalized ? 1 : -1;
};

const getValueByProperties = (obj, property) => {
    const properties = Array.isArray(property) ? property : [property];

    for (let i = 0; i < properties.length; i += 1) {
        if (has(obj, properties[i])) {
            return get(obj, properties[i]);
        }
    }

    return '';
};

const isLastNameProperty = (property) => {
    const properties = Array.isArray(property) ? property : [property];

    return properties.some((prop) => prop === 'lastName' || prop === 'sitecoreData.lastName');
};
